import React, {memo, useCallback} from 'react';
import * as Common from 'bodycodi/cmap/app/js/common';
import Dialog from '@material-ui/core/Dialog';
import 'bodycodi/cmap/app/css/common/alert.css';

function Alert({open, setOpen, header, body, cancelAlert, closeAlert, cancleYn, redYn, redButtonLabel = "", greenButtonLabel = ""}){

    const handleClose = useCallback(() => {
        setOpen(false);
        if(!Common.isEmpty(closeAlert)){
            closeAlert();
        } 
    }, [closeAlert, setOpen]);
    
    const handleClose1 = useCallback(() => {
        if(!Common.isEmpty(cancelAlert)){
            cancelAlert();
        }
        setOpen(false);
    }, [setOpen]);

    return (
        <Dialog open={open} onClose={handleClose1} className="alert-pop" classes={{ paper: 'alert' }}>
            <div className="alert-header">
                <span>{header}</span>
            </div>
            <div className="alert-header-bar"></div>                      
            <div className="alert-body">
                <p>{body}</p>                        
            </div> 
            <div className="alert-footer">   
                {cancleYn==true && (
                    <>
                        <div className="alert-footer-half-button black" onClick={handleClose1}>취소</div>    
                        <div className={"alert-footer-half-button"+(redYn? " red" : " blue")} onClick={handleClose}>확인</div>
                    </>
                )}
                {!cancleYn==true && (
                    <div className="alert-footer-button" onClick={handleClose}>확인</div>     
                )}   
                {cancleYn=='D' && (
                    <>
                        <div className="alert-footer-half-button black" onClick={handleClose1}>취소</div>    
                        <div className={"alert-footer-half-button red"} onClick={handleClose}>{redButtonLabel ? redButtonLabel : '삭제'}</div>
                    </>
                )}
                {cancleYn=='C' && (
                    <div className="alert-footer-button black" onClick={handleClose1}>취소</div>
                )}                       
                {cancleYn=='G' && (
                    <>
                        <div className="alert-footer-half-button black" onClick={handleClose1}>취소</div>    
                        <div className={"alert-footer-half-button green"} onClick={handleClose}>{greenButtonLabel ? greenButtonLabel : '확인'}</div>
                    </>
                )}                       
            </div>
        </Dialog>
    )
}

export default memo(Alert);